import { useEffect, useState } from 'react';
import {
  consumePendingPostOnboardingState,
  type PendingPostOnboardingState,
} from '@/auth/sessionStorage';

export const usePendingPostOnboardingState = (
  userId: string | null | undefined,
): PendingPostOnboardingState | null => {
  const [pendingPostOnboardingState, setPendingPostOnboardingState] =
    useState<PendingPostOnboardingState | null>(null);

  useEffect(() => {
    if (!userId) return;
    setPendingPostOnboardingState((current) => {
      if (current !== null) {
        return current;
      }
      return consumePendingPostOnboardingState(userId);
    });
  }, [userId]);

  return pendingPostOnboardingState;
};
